import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';

import logo from 'assets/images/logo/logoXpoPRO.png';
import 'react-toastify/dist/ReactToastify.css';

export default class SponsorView extends Component {
  render() {
    return (
      <div className="sponsorView">

        <div className="gradient" />
        <div className="bg" />

        <div className="sponsorHolder">

          <div className="title">
            <span>Main Sponsors</span>
          </div>

          <div className="sponsors">

            <div className="sponsor">
              <Link to="/profile">
                <img className="company__image" alt="user" src="https://www.festivalclaca.cat/pics/b/17/174568_amazon-logo-png-transparent-background.png" />
                <span>Sponsor Name</span>
                <div className="booth__location">
                  Hall: Internationals
                </div>
              </Link>
            </div>

            <div className="sponsor">
              <Link to="/profile">
                <img className="company__image" alt="user" src="https://www.festivalclaca.cat/pics/b/17/174568_amazon-logo-png-transparent-background.png" />
                <span>Sponsor Name</span>
                <div className="booth__location">
                  Hall: Internationals
                </div>
              </Link>
            </div>

            <div className="sponsor">
              <Link to="/profile">
                <img className="company__image" alt="user" src="https://www.festivalclaca.cat/pics/b/17/174568_amazon-logo-png-transparent-background.png" />
                <span>Sponsor Name</span>
                <div className="booth__location">
                  Hall: Internationals
                </div>
              </Link>
            </div>

            <div className="sponsor">
              <Link to="/profile">
                <img className="company__image" alt="user" src="https://www.festivalclaca.cat/pics/b/17/174568_amazon-logo-png-transparent-background.png" />
                <span>Sponsor Name</span>
                <div className="booth__location">
                  Hall: Internationals
                </div>
              </Link>
            </div>

          </div>

          <div className="title subtitle">
            <span>Sub Sponsors</span>
          </div>

          <div className="sponsors sub">
            <div className="sponsor">
              <Link to="/profile">
                <img className="company__image" alt="user" src="https://www.festivalclaca.cat/pics/b/17/174568_amazon-logo-png-transparent-background.png" />
                <span>Sponsor Name</span>
                <div className="booth__location">
                  Hall: Internationals
                </div>
              </Link>
            </div>

            <div className="sponsor">
              <Link to="/profile">
                <img className="company__image" alt="user" src="https://www.festivalclaca.cat/pics/b/17/174568_amazon-logo-png-transparent-background.png" />
                <span>Sponsor Name</span>
                <div className="booth__location">
                  Hall: Internationals
                </div>
              </Link>
            </div>

            <div className="sponsor">
              <Link to="/profile">
                <img className="company__image" alt="user" src="https://www.festivalclaca.cat/pics/b/17/174568_amazon-logo-png-transparent-background.png" />
                <span>Sponsor Name</span>
                <div className="booth__location">
                  Hall: Internationals
                </div>
              </Link>
            </div>

            <div className="sponsor">
              <Link to="/profile">
                <img className="company__image" alt="user" src="https://www.festivalclaca.cat/pics/b/17/174568_amazon-logo-png-transparent-background.png" />
                <span>Sponsor Name</span>
                <div className="booth__location">
                  Hall: Internationals
                </div>
              </Link>
            </div>

            <div className="sponsor">
              <Link to="/profile">
                <img className="company__image" alt="user" src="https://www.festivalclaca.cat/pics/b/17/174568_amazon-logo-png-transparent-background.png" />
                <span>Sponsor Name</span>
                <div className="booth__location">
                  Hall: Internationals
                </div>
              </Link>
            </div>

          </div>

        </div>
      </div>
    );
  }
}
